import { styled } from 'linaria/react';

export const TableContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: var(--space-275);

  & > div {
    display: flex;
    flex-direction: column;
    gap: var(--space-150);
  }
`;

export const SurfaceColumnContainer = styled.div`
  min-width: 120px;

  @media (--only-tablet) {
    min-width: 130px;
  }

  @media (--only-mobile) {
    min-width: 35%;
  }
`;

export const MaterialColumnContainer = styled.div`
  min-width: 230px;
`;

export const AreaColumnContainer = styled.div`
  min-width: 91px;
`;

export const VolumeColumnContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  min-width: 140px;

  @media (--only-tablet) {
    min-width: 125px;
  }

  @media (--only-mobile) {
    min-width: auto;
    margin-left: auto;
    text-align: right;
  }
`;

export const CounterContainer = styled.div`
  flex-grow: 1;
  min-width: 129px;
  margin-right: var(--space-100);
  margin-left: var(--space-100);

  @media (--only-mobile) {
    order: 1;
    flex-grow: unset;
    margin-right: var(--space-125);
    margin-left: auto;
  }
`;

export const PriceColumnContainer = styled.div`
  white-space: nowrap;

  @media (--only-mobile) {
    order: 1;
  }
`;
